import { React, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import Footer from "components/VerticalLayout/Footer";
import { get, uri } from "helpers/api_helper";
import * as api from "../../constants/api_constants";
import { formatToPascal } from "helpers/utils/nameUtils";
import DragAndDropComponent from "components/FileUploadDrag/DragAndDrop";

function ViewProject() {
  const navigate = useNavigate();
  const { projId } = useParams();
  const [customers, setCustomers] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [project, setProject] = useState({});
  const [projectDocuments, setProjectDocuments] = useState([]);

  const [fetchedProjData, setFetchedProjData] = useState({
    projectName: "",
    customer: "",
    status: "",
    startDate: "",
    endDate: "",
    priority: "",
    budget: "",
    spentAmount: "",
    remainingBudget: "",
    projectDetailsId: "",
    projectTeamId: "",
    tags: "",
    description: "",
    projectManager: "",
    teamMembers: [],
    roles: "",
    contactInfo: "",
    jiraUrl: "",
    gitUrl: "",
  });

  useEffect(() => {
    async function doFetchCalls() {
      await fetchProjectData(projId);
    }
    doFetchCalls();
    return () => {};
  }, [projId]);

  const fetchProjectData = async (projId) => {
    try {
      // Fetch customers
      const getCustomer = await get(api.GET_ALL_CUSTOMERS_ID_NAME_MAIL_CURRENCY);
      const updatedCustData = getCustomer.map((item) => ({
        value: item.customerId,
        label: `${item.companyName}-   (${item.customerCode})`,
      }));
      setCustomers(updatedCustData);

      // Fetch project data
      const response = await get(api.GET_PROJECT_BY_ID(projId));
      const projectData = response?.paginationResponse?.data[0];
      setProject(projectData);  
      console.log(projectData);
      

      // Fetch customer name
      const custname = updatedCustData.filter(
        (item) => item.value === projectData.customerId
      );

      // Fetch employees
      const res = await get(api.GET_ALL_EMPLOYEES_NAME_ID_MAIL);
      const employeeResponse = res.map((item) => ({
        value: item.employeeId,
        label: `${item.firstName} ${item.lastName}`,
      }));
      const projManagerName = employeeResponse.filter(
        (item) =>
          item.value ===
          projectData?.projectDetailsTO?.projectTeamTOList?.[0]?.projectManagerId
      );
      setEmployee(employeeResponse);
      console.log("employeeResponse",projectData);
      

      // Fetch file details for projectDocuments
      const projectDocs = projectData?.projectDocuments || [];
      const fileDetails = await Promise.all(
        projectDocs.map(async (fileId) => {
          try {
            const fileResponse = await get(`${uri}/fileservice/api/files/view/${fileId}`);
            return {
              id: fileResponse.id,
              fileName: fileResponse.fileName,
              name: fileResponse.fileName, // Match AddProject's structure
              path: fileResponse.path || `/uploads/${fileResponse.fileName}`,
            };
          } catch (error) {
            console.error(`Error fetching file ${fileId}:`, error);
            return null;
          }
        })
      );
      setProjectDocuments(fileDetails.filter((file) => file !== null));

      setFetchedProjData({
        projectName: projectData?.projectName || "",
        customer: custname[0]?.label || "",
        status: formatToPascal(projectData?.status) || "",
        startDate: projectData?.projectDetailsTO?.startDate || "",
        endDate: projectData?.projectDetailsTO?.endDate || "",
        priority: formatToPascal(projectData?.projectDetailsTO?.priority) || "",
        budget: projectData?.projectDetailsTO?.budget || "",
        spentAmount: projectData?.projectDetailsTO?.spentAmount || "",
        remainingBudget: projectData?.projectDetailsTO?.remainingBudget || "",
        tags: projectData?.tags || "",
        description: projectData?.description || "",
        projectTeamId:
          projectData?.projectDetailsTO?.projectTeamTOList[0]?.projectTeamId || "",
        projectDetailsId: projectData?.projectDetailsTO?.projectDetailsId || "",
        projectManager: projManagerName[0]?.label || "",
        teamMembers:
          projectData?.projectDetailsTO?.projectTeamTOList?.[0]?.employeeIdList || [],
        roles: projectData?.projectDetailsTO?.projectTeamTOList?.[0]?.roles || "",
        contactInfo:
          projectData?.projectDetailsTO?.projectTeamTOList?.[0]?.contactInformation || "",
        gitUrl: projectData?.gitHubUrl || "",
        jiraUrl: projectData?.jiraUrl || "",
      });
    } catch (error) {
      console.error("Error fetching project data:", error);
    }
  };

  return (
    <div className="page-content">
      <Container fluid={true} style={{ padding: "0px", gap: "10px" }}>
        <PageSubHeader
          heading={"View Project"}
          routePath={"Home"}
          pageName={"Project Details"}
        />
        <Row className="p-4">
          <Col>
            <Card>
              <CardBody>
                <Form
                  className="row g-3 needs-validation py-4"
                  onSubmit={(e) => {
                    e.preventDefault();
                    return false;
                  }}
                >
                  <Row>
                    <Row className="card-group">
                      <Col xs={12} className="card-header">
                        <p className="form-header">Project Information</p>
                      </Col>
                      <Col md="6" className="pt-2">
                        <FormGroup className="mb-3">
                          <Label htmlFor="customer">
                            Customer  
                          </Label>
                          <Input
                            disabled
                            name="customer"
                            className="form-control"
                            id="customer"
                            value={fetchedProjData.customer}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6" className="pt-2">
                        <FormGroup className="mb-3">
                          <Label htmlFor="projectName">
                            Project Name  
                          </Label>
                          <Input
                            disabled
                            name="projectName"
                            type="text"
                            className="form-control"
                            id="projectName"
                            value={fetchedProjData.projectName}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="projectManager">
                            Project Manager  
                          </Label>
                          <Input
                            disabled
                            name="projectManager"
                            className="form-control"
                            id="projectManager"
                            value={fetchedProjData.projectManager}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="teamMembers">
                            Team Members  
                          </Label>
                          <Select
                            isDisabled
                            isMulti
                            name="teamMembers"
                            options={employee}
                            value={employee.filter((empId) =>
                              fetchedProjData.teamMembers.includes(empId.value)
                            )}
                            className="basic-multi-select"
                            classNamePrefix="select"
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="status">
                            Status  
                          </Label>
                          <Input
                            disabled
                            name="status"
                            className="form-select"
                            id="status"
                            value={fetchedProjData.status}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="jiraUrl">
                            jiraURL  
                          </Label>
                          <Input
                            disabled
                            name="jiraUrl"
                            className="form-control"
                            id="jiraUrl"
                            value={fetchedProjData.jiraUrl}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="gitUrl">
                            gitURL  
                          </Label>
                          <Input
                            disabled
                            name="gitUrl"
                            className="form-control"
                            id="gitUrl"
                            value={fetchedProjData.gitUrl}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="card-group mt-3">
                      <Col xs={12} className="card-header">
                        <p className="form-header">Project Details</p>
                      </Col>
                      <Col md="6" className="pt-2">
                        <FormGroup className="mb-3">
                          <Label htmlFor="startDate">
                            Start Date  
                          </Label>
                          <Input
                            disabled
                            name="startDate"
                            type="date"
                            className="form-control"
                            id="startDate"
                            value={fetchedProjData.startDate}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6" className="pt-2">
                        <FormGroup className="mb-3">
                          <Label htmlFor="endDate">
                            End Date  
                          </Label>
                          <Input
                            disabled
                            name="endDate"
                            type="date"
                            className="form-control"
                            id="endDate"
                            value={fetchedProjData.endDate}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="priority">
                            Priority  
                          </Label>
                          <Input
                            disabled
                            name="priority"
                            className="form-select"
                            id="priority"
                            value={fetchedProjData.priority}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="budget">
                            Budget  
                          </Label>
                          <Input
                            disabled
                            name="budget"
                            type="text"
                            className="form-control"
                            id="budget"
                            value={fetchedProjData.budget}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="spentAmount">
                            Spent Amount  
                          </Label>
                          <Input
                            disabled
                            name="spentAmount"
                            type="text"
                            className="form-control"
                            id="spentAmount"
                            value={fetchedProjData.spentAmount}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6">
                        <FormGroup className="mb-3">
                          <Label htmlFor="remainingBudget">
                            Remaining Budget  
                          </Label>
                          <Input
                            disabled
                            name="remainingBudget"
                            type="text"
                            className="form-control"
                            id="remainingBudget"
                            value={fetchedProjData.remainingBudget}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="12">
                        <FormGroup className="mb-3">
                          <Label htmlFor="description">Description</Label>
                          <Input
                            disabled
                            name="description"
                            type="textarea"
                            className="form-control"
                            id="description"
                            rows={3}
                            value={fetchedProjData.description}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="card-group mt-3 flex">
                      <Col xs={12} className="card-header">
                        <p className="form-header">Project Documents</p>
                      </Col>
                      <Col md={3}>
                        {projectDocuments.length > 0 ? (
                          projectDocuments.map((doc) => (
                            <div key={doc.id} className="position-relative rounded py-2 pe-4 mb-3">
                              <DragAndDropComponent
                                initialFile={doc}
                                readOnly={true}
                              />
                            </div>
                          ))
                        ) : (
                          <p>No documents available.</p>
                        )}
                      </Col>
                    </Row>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer
        saveText="Edit Project"
        save={() => navigate(`/add-project/${projId}`)}
        showBackConfirmation={false}
      />
    </div>
  );
}

export default ViewProject;